import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface RoutePopupProps {
    onClose: () => void;
}

function RoutePopup({ onClose }: RoutePopupProps) {
    const [show, setShow] = useState(false);
    const { user } = useSelector((state: RootState) => state.auth);
    const isAdmin = user?.roles.includes('admin');
    useEffect(() => {
        // Delay để bật hiệu ứng trượt xuống
        setTimeout(() => setShow(true), 10);
    }, []);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setShow(false);
            setTimeout(onClose, 300); // đợi animation kết thúc mới đóng
        }
    };

    return (
        <div
            className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
            onClick={handleOverlayClick}
            style={{ opacity: show ? 1 : 0 }}
        >
            <div
                className={`relative w-[90%] lg:w-[600px] h-fit lg:min-h-[300px] bg-white p-[40px] rounded-box flex justify-center items-center flex-col transform transition-all duration-300 ${show ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
                    }`}
            >
                <h2 className="text-secondary font-bold text-[20px] mt-[20px]">
                    {user && !isAdmin ? "Bạn không có quyền truy cập đường dẫn này!" : "Hãy đăng nhập trước khi truy cập đường dẫn này!"}
                </h2>
                <button
                    className="absolute top-[10px] right-[10px] text-[16px] text-red-500"
                    onClick={() => {
                        setShow(false);
                        setTimeout(onClose, 300);
                    }}
                >
                    <i className="fa-solid fa-close text-[20px] text-blue-500"></i>
                </button>
            </div>
        </div>
    );
}

export default RoutePopup;
